import React from 'react';
import { Stack, ControlLink, Text, AspectRatioBox } from '@moda/om';
import { Image } from '../../Image';
import { RequestReturnPrintableLabel } from '../RequestReturnPrintableLabel';
import { RequestReturnNonEligibleReason } from './RequestReturnNonEligibleReason';
import { useNonEligibleItems } from './useNonEligibleItems';

import './RequestReturnNonEligibleItems.scss';

export const RequestReturnNonEligibleItems: React.FC = () => {
  const nonEligibleItems = useNonEligibleItems();

  if (nonEligibleItems.length === 0) return null;

  return (
    <Stack space={5}>
      <Stack space={3}>
        <Text>Why don't I see my other items from this order?</Text>
        <Text>
          If your item was final sale, we cannot accept the return. Find out more information{' '}
          <ControlLink href="https://help.modaoperandi.com/hc/en-us/articles/211521863-Return-Policy">
            here
          </ControlLink>
          .
        </Text>
      </Stack>

      <Stack space={4}>
        <Text treatment="h5">Items in this Order Not Eligible for Return</Text>

        <div className="RequestReturnNonEligibleItems__grid">
          {nonEligibleItems.map(item => (
            <Stack key={item.id} space={2} alignItems="center">
              <AspectRatioBox maxHeight={270} maxWidth={170}>
                <Image src={item.attributes.images.medium} />
              </AspectRatioBox>

              <RequestReturnNonEligibleReason item={item} />

              <RequestReturnPrintableLabel item={item} />
            </Stack>
          ))}
        </div>
      </Stack>
    </Stack>
  );
};
